import React, { Component } from 'react';
import gallery from "../../../data/gallery.json";
import Slider from 'react-slick';

const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
}

class Gallery extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }
    next() {
        this.slider.slickNext();
    }
    previous() {
        this.slider.slickPrev();
    }
    render() {
        return (
            <div className="section secondary-bg pt-0">
                <div className="container">
                    <div className="row align-items-center sigma_expaneded-row sigma_related-posts">
                        {/* Section Header Start */}
                        <div className="col-lg-4">
                            <div className="section-title">
                                <h6 className="subtitle text-white secondary cursive-style">Gallery</h6>
                                <h4 className="title text-white">Church Life</h4>
                                <p>Cras ultricies ligula sed magna dictum porta. Curabitur non nulla sit amet nisl tempus convallis quis ac lectus.</p>
                            </div>
                            {/* Custom Arrows Start */}
                            <div className="sigma_arrows sigma_arrows-transparent mb-lg-30">
                                <div className="sigma_round-arrow prev-arrow">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" style={{  }} viewBox="0 0 197 197" enableBackground="new 0 0 197 197" xmlSpace="preserve">
                                        <circle className="sigma_round-arrow-stroke" strokeLinecap="round" cx="98.5" cy="98.6" r="97.5" />
                                        <circle className="sigma_round-arrow-circle" strokeLinecap="round" cx="98.5" cy="98.6" r="97.5" />
                                    </svg>
                                    <i className="far fa-chevron-left slick-arrow slider-prev" onClick={this.previous} />
                                </div>
                                <div className="sigma_round-arrow next-arrow">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" style={{  }} viewBox="0 0 197 197" enableBackground="new 0 0 197 197" xmlSpace="preserve">
                                        <circle className="sigma_round-arrow-stroke" strokeLinecap="round" cx="98.5" cy="98.6" r="97.5" />
                                        <circle className="sigma_round-arrow-circle" strokeLinecap="round" cx="98.5" cy="98.6" r="97.5" />
                                    </svg>
                                    <i className="far fa-chevron-right slick-arrow slider-next" onClick={this.next} />
                                </div>
                            </div>
                            {/* Custom Arrows End */}
                        </div>
                        {/* Section Header End */}
                        {/* Blog Post Start */}
                        <div className="px-3 w-100 position-relative">
                            <Slider ref={c => (this.slider = c)} {...settings} className="sigma_related-slider">
                                {/* Data */}
                                {gallery.map((item, i) => (
                                    <div key={i}>
                                        {item.image.map((image, i) => (
                                            <a rel={"external"} href={image} className="gallery-thumb" key={i}>
                                                <img src={process.env.PUBLIC_URL + "/" + image} alt="img" />
                                            </a>
                                        ))}
                                    </div>
                                ))}
                                {/* Data */}
                            </Slider>
                        </div>
                        {/* Blog Post End */}
                    </div>
                </div>
            </div>
        );
    }
}

export default Gallery;